import { Service } from "../../config/service";

class VehiclesService extends Service {
    constructor(id = "") {
        super("vehicles", id);
    }

    async getFiles(id, config = {}) {
        try {
            const response = await this.http84.get(`${this.getResource().list}/${id}/files`, { params: this.getParams(), ...config })
            return Promise.resolve(response.data)
        } catch (e) {
            this.setError(e)
            return Promise.reject(this.getError())
        }
    }
}


export default VehiclesService;
